import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

type Account = {
	id: string
	email: string
	type: number
	name: string
	streetAddress1: string | null
	streetAddress2: string | null
	city: string | null
	state: string | null
	phone: string
	subscriptionId: string | null
	backupToolInstalled: boolean
	backupToolOutOfDate: boolean
	backupToolInstanceVersions: string[]
	latestBackupToolVersion: string
	isDisabled: boolean
}

export const getAccounts = (): Promise<Account[]> => {
	return api.get('/accounts')
}

export const getAccountsQueryOptions = () => {
	return queryOptions({
		queryKey: ['accounts'],
		queryFn: () => getAccounts(),
	})
}

type UseAccountsOptions = {
	queryConfig?: QueryConfig<typeof getAccounts>
}

export const useAccounts = ({ queryConfig }: UseAccountsOptions = {}) => {
	return useQuery({
		...getAccountsQueryOptions(),
		...queryConfig,
	})
}


